'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiGrid = undefined;

var _MultiGrid = require('./MultiGrid');

var _MultiGrid2 = _interopRequireDefault(_MultiGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MultiGrid2.default;
exports.MultiGrid = _MultiGrid2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/commonjs/MultiGrid/index.js
// module id = 1418
// module chunks = 0